// External app integrations are not operational yet. Historical rows must not
// be presented as real connections, and UI actions must never write fake states.
export const useAppConnections = () => ({
  connectedApps: {} as Record<string, { status: 'active' | 'pending' | 'error' }>,
  isLoading: false,
  handleConnect: async (_appName: string, _authUrl: string) => {},
  handleDisconnect: async (_appName: string) => {},
});
